import { topics } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            热门话题
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            全网影迷正在热议的影视话题，看看大家都在聊什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className="group inline-flex items-center gap-3 px-5 py-3 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap group-hover:text-primary-600 transition-colors">
                #{item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              {item.tag && (
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap ${
                  item.tag === '热' ? 'bg-accent-100 text-accent-700' :
                  item.tag === '新' ? 'bg-primary-100 text-primary-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}